// see src/app/shared/constant/analytics/Category.ts:1 in optim-portal-front
import {Advertising} from '../../domain/advertising/model/advertising';

export class AnalyticsCategory {
  static readonly leftMenu = 'MenuGauche';
  static readonly assistance = 'Assistance';
  static readonly advertising = 'Advertising';
  static readonly rightPanel = 'PartieDroite';
  static readonly widget = 'Widget';
  static readonly publicite = 'Publicite_Event';

}
